export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGNED_OUT_USER = 'SIGNED_OUT_USER';
export const SIGNING_IN_USER = 'SIGNING_IN_USER';
export const FIRST_TIME_SIGNIN = 'FIRST_TIME_SIGNIN';
export const SET_USERNAME = 'SET_USERNAME'
interface HttpErrorResponse {
    data: string;
    message: string;
    status: number;
}

export class ErrorResponse implements HttpErrorResponse {
    constructor(public data: string, public message: string, public status: number) { }
}

export interface Action<T = any> {
    type: string;
    payload?: T;
}
